<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  list-style: none;
  text-decoration: none;
  font-family: 'Nanum Barun Gothic', sans-serif;
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #e6e6e6;
  width: 100%;
  height: 100vh;
}

/* date-picker overriding */
.date-picker-list-input {
  width: 155px;
  padding-left: 5px;
  margin-left: 1vw;
  height: 32px;
  position: relative;
  bottom: 3px;
  border: none;
  background-color: #f5f5f5;
  display: inline-block;
  font-size: 1.2rem;
}
.date-picker-hide-input {
  display: none;
}
.date-picker-calendar {
  left: 10vw;
  color: black;
}
.date-picker-work-calendar {
  color: black;
  line-height: 45px;
  font-size: 20px;
}
.vdp-datepicker {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue